import { Route } from "react-router-dom";
import ClientServiceDetails from "../components/index";

const ClientServiceDetailsRoutes = () => (
  <>
    <Route path="/client-service/details/:id" element={<ClientServiceDetails />} />
  </>
);


export default ClientServiceDetailsRoutes;